import { Box, Modal } from '@mui/material';

import layout from '../styles/layout.module.css';
const ModalView = ({ open, handleClose, children, action, containerStyle, windowStyle }) => {
    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                className={layout.modalResetContainer}
                style={{
                    ...containerStyle
                }}>
                <Box
                    className={layout.modelResetWindow}
                    style={{
                        ...windowStyle
                    }}>
                    {children}
                    {action}
                </Box>
            </Box>
        </Modal>
    );
};

export default ModalView;
